import { ProfilePromiseActionService } from "./ProfilePromiseActionService";
import { ProfileSettingKeys } from "../../model/core/ProfileSettingKeys";

import { Injectable } from "@angular/core";

import { Subject, Observable } from "rxjs";

/*
 * TODO: Port component to a Primary/Replica service
 * providing sorts, defaults etc
 *
 * /until then/or/ keep this as a thin as possible & align
 * with changes in BfxOrderBlotterSettingsTemperatureComponent
 *
 */
const PROFILE_KEY = ProfileSettingKeys.userProfileSettingsOrderBlotterTemperatures;
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class UserTemperatureService {
  private userTemperatureMap = new Map();
  private updates: Subject<string[]> = new Subject();
  private;
  constructor(profileActionService: ProfilePromiseActionService) {
    profileActionService.getProfileConfig(PROFILE_KEY).then((profileValue) => {
      this.parseProfileValue(profileValue);
      profileActionService.getProfileConfigUpdates(PROFILE_KEY).subscribe((profileValue) => {
        this.parseProfileValue(profileValue);
      });
    });
  }

  private parseProfileValue(profileValue: string) {
    let userTemps = null;
    let productCodes = new Set(this.userTemperatureMap.keys());

    this.userTemperatureMap.clear();

    try {
      userTemps = JSON.parse(profileValue);
    } catch (e) {
      // no user temps
    }

    if (Array.isArray(userTemps)) {
      userTemps.forEach((userTemp) => {
        let productCode =
          userTemp.ccyPairIdentifier.slice(0, 3) + userTemp.ccyPairIdentifier.slice(4);
        this.userTemperatureMap.set(productCode, userTemp);

        productCodes.add(productCode);
      });
    }

    // all productCodes that were changed (modified or removed)
    this.updates.next(Array.from(productCodes));
  }

  public getUserTempUpdates(): Observable<string[]> {
    return this.updates.asObservable();
  }

  public getUserTemp(baseCode: string, nonBaseCode: string): any {
    const productCode = `${baseCode}${nonBaseCode}`;

    return this.userTemperatureMap.get(productCode);
  }
}
